document.querySelectorAll('[data-booking]').forEach(component => {
  if (component.dataset.bookingReady) return;
  component.dataset.bookingReady = 'true';
  const trigger = component.querySelector('[data-booking-open]');
  const dialog = component.querySelector('[data-booking-dialog]');
  const frameHost = dialog.querySelector('[data-booking-frame]');
  if (typeof dialog.showModal !== 'function') return;
  document.body.append(dialog);
  trigger.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (!frameHost.querySelector('iframe')) {
      const frame = document.createElement('iframe');
      frame.title = frameHost.dataset.bookingTitle;
      frame.src = dialog.dataset.bookingSrc;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frameHost.append(frame);
    }
    if (!dialog.open) dialog.showModal();
  });
  dialog.querySelector('[data-booking-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('cancel', event => event.stopPropagation());
  dialog.addEventListener('close', () => {
    frameHost.replaceChildren();
    trigger.focus({ preventScroll: true });
  });
});
